











import Vue from 'vue';
import VacancyFilterJumbotron from "@/components/vacancy-search/VacancyFilterJumbotron.vue";
import {FoundVacancies} from "@/model/find-vacancies-response";
import {VacancyListFilter} from "@/model/vacancy-list-filter";
import * as env from "@/utils/globals";
import {VacancyCollection} from "@/service/vacancy-collection";

interface VM {
  calculatedVacancies: FoundVacancies | null;
}

export default Vue.extend({
  name: 'VacancySearchWrapper',
  components: {
    VacancyFilterJumbotron,
  },
  props: {
    backgroundImageLink: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    targetUrl: {
      type: String,
      default: ''
    },
    activeFilter: {
      type: Object as () => VacancyListFilter,
      default: () => new VacancyListFilter()
    },
    foundVacancies: {
      type: Object as () => FoundVacancies,
    },
  },
  data(): VM {
    return {
      calculatedVacancies: null
    };
  },
  computed: {
    vacancies(): FoundVacancies | {} {
      return this.calculatedVacancies || this.foundVacancies;
    },
  },
  methods: {
    onUpdate() {
        if ((this.$listeners as Record<string, Function>).updated) {
          this.$emit('updated');
          return;
        }

        window.location.href = this.activeFilter.clone().getUrl(env.getConfig().searchPath || "#");
    },
    refresh() {
      // quite an ugly hack for now should be refactored in the future
      if (this.$listeners && this.$listeners.updated) {
        return;
      }
      this.getFilterInformation();
    },

    getFilterInformation() {
      const searchParams = this.activeFilter.getFilter();

      VacancyCollection.getInstance()
        .findVacancies(searchParams)
        .then(found => {
          this.calculatedVacancies = found;
        });
    }
  },
  mounted() {
    this.refresh();
  },
});
